import { render } from "./NotFoundView.vue?vue&type=template&id=5d1a5b0e&scoped=true&ts=true"
import script from "./NotFoundView.ts?vue&type=script&lang=ts"
export * from "./NotFoundView.ts?vue&type=script&lang=ts"

import "./NotFoundView.scss?vue&type=style&index=0&id=5d1a5b0e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1a5b0e"]])

export default __exports__